// Catálogo central de Rubros/Industrias para AIGIS Certificate.
// Usado en: AdminClients, AdminInspectors, AdminCatalog, NewRequest.
// Mantener ordenado por categoría.

export const INDUSTRIES = [
    // Hospedaje
    'Hotelería',
    'Hotelería Boutique',
    'Hostales y Hospedaje Económico',
    'Resorts y Hoteles Todo Incluido',

    // Alimentos y bebidas
    'Restaurantes',
    'Bares y Cantinas',
    'Cafeterías',
    'Discotecas / Antros',
    'Casinos',
    'Salones de Eventos',

    // Comercio
    'Plazas Comerciales',
    'Centros Comerciales',
    'Comercio Minorista (Retail)',
    'Supermercados',
    'Farmacias',
    'Tiendas de Conveniencia',

    // Entretenimiento
    'Cines y Salas de Espectáculos',
    'Parques de Diversiones',
    'Centros de Entretenimiento',

    // Educación
    'Educación — Escuelas (Básica)',
    'Educación — Preparatoria',
    'Educación — Universidades',
    'Centros de Capacitación',
    'Guarderías',

    // Salud y bienestar
    'Hospitales y Clínicas',
    'Consultorios y Centros Médicos',
    'Spas y Centros de Belleza',
    'Gimnasios y Centros Deportivos',
    'Asilos / Casas de Retiro',

    // Servicios profesionales
    'Servicios Profesionales (Consultoría, Despachos)',
    'Servicios Financieros (Bancos, Aseguradoras)',
    'Servicios Inmobiliarios',
    'Servicios de TI y Tecnología',
    'Oficinas Corporativas',
    'Coworking',

    // Industria y operación
    'Industria Manufacturera',
    'Industria Alimenticia',
    'Industria Química y Farmacéutica',
    'Industria Textil',
    'Industria Automotriz',
    'Agroindustria',
    'Construcción y Obras',
    'Minería',

    // Logística y movilidad
    'Almacenes y Logística (Bodegas)',
    'Transporte y Flotillas',
    'Estaciones de Servicio (Gasolineras)',
    'Aeropuertos y Terminales',

    // Otros
    'Gobierno y Sector Público',
    'Organizaciones sin Fines de Lucro',
];

export default INDUSTRIES;
